import { TradeInPreviewAcquisition } from '@carvana/merch-contracts';
import { isSuccess, Result } from '@carvana/merch-result';
import { type MerchUiTradeV2Response } from '~/app/api/v2/trades/route';
import { httpWithAuth } from '~/clients';
import { MerchUiApiClientId } from '~/constants/common/ApiClientId';
import { getTradesV2 } from '~/constants/endpoints';

export default async function fetchTradeInPreviewAcquisitions(
  correlationId: string
): Promise<TradeInPreviewAcquisition[]> {
  const url = getTradesV2({ currentPageUrl: window.location.href });

  const { data } = await httpWithAuth.get<Result<MerchUiTradeV2Response>>(url, {
    headers: {
      'x-client-id': MerchUiApiClientId,
      'x-correlation-id': correlationId
    }
  });

  return isSuccess(data) ? data.content.trades : [];
}
